import React, { useEffect, useState } from "react";
import Loading from "../Modals/Loading";
import { useNavigate } from "react-router-dom";
import roleService from "../Services/roleService";
import { FiEdit3 } from "react-icons/fi";
import { LuEye } from "react-icons/lu";
import Head from "../Components/Head";

const Role = () => {
  const [loading, setLoading] = useState(false);
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    const getRoles = async () => {
      try {
        setLoading(true);
        const response = await roleService.getAll();
        setRoles(response.roles);
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    };
    getRoles();
  }, []);

  const handleToggleStatus = async (role) => {
    setLoading(true);
    try {
      if (role.status === "active") {
        await roleService.deactivate(role.id);
        setRoles((prevRoles) =>
          prevRoles.map((r) =>
            r.id === role.id ? { ...r, status: "inactive" } : r,
          ),
        );
      } else {
        await roleService.activate(role.id);
        setRoles((prevRoles) =>
          prevRoles.map((r) =>
            r.id === role.id ? { ...r, status: "active" } : r,
          ),
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const navigate = useNavigate();
  return (
    <main className="mx-10 mt-2 p-6 rounded-3xl border border-gray-200 shadow-lg bg-white min-h-[calc(100vh-48px)]">
      {loading ? (
        <Loading />
      ) : (
        <>
          <Head
            heading={"Roles"}
            button_text={"Add Role"}
            navigation={() => navigate("/roles/add")}
          />
          {/* Table */}
          <div className="table-div">
            <table>
              <thead>
                <tr className="border-y-2 text-center w-full text-black text-[10px]">
                  <th className="py-4 w-[4%] rounded-tl-lg text-left pl-4">
                    Name
                  </th>
                  <th className="py-4 w-[4%]">Status</th>
                  <th className="py-4 w-[4%]">Details</th>
                  <th className="py-4 w-[2%]">Edit</th>
                  <th className="py-4 w-[2%] rounded-tr-lg">Actions</th>
                </tr>
              </thead>
              <tbody>
                {roles.map((value, index) => (
                  <tr
                    key={index}
                    className="bg-accent border-b border-gray-100 text-left"
                  >
                    <td className="py-3 w-[4%] pl-4 font-bold">{value.name}</td>
                    <td className="py-3 w-[1%]">
                      <div className="flex justify-center">
                        <p
                          className={`flex px-4 py-[1px] rounded-md bg-opacity-20 font-semibold uppercase ${
                            value.status === "active"
                              ? "bg-green-500 text-green-500"
                              : "bg-red-500 text-red-500"
                          }`}
                        >
                          {value.status}
                        </p>
                      </div>
                    </td>
                    <td className="py-3 w-[4%] text-center">
                      <button
                        onClick={() =>
                          navigate("/roles/permission?id=" + value.id)
                        }
                      >
                        <LuEye className="h-4 w-4 text-sky-500" />
                      </button>
                    </td>
                    <td className="py-3 w-[2%] text-center">
                      <button
                        onClick={() => navigate("/roles/edit?id=" + value.id)}
                      >
                        <FiEdit3 className="h-4 w-4 text-indigo-500" />
                      </button>
                    </td>
                    <td className="py-3 w-[4%] text-center">
                      <button
                        onClick={() => handleToggleStatus(value)}
                        className={`px-3 py-1 text-xs rounded bg-opacity-20 font-semibold ${
                          value.status === "active"
                            ? "bg-red-500 text-red-500"
                            : "bg-green-500 text-green-500"
                        }`}
                      >
                        {value.status === "active" ? "Deactivate" : "Activate"}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </main>
  );
};

export default Role;
